import { render, staticRenderFns } from "./headerv2.vue?vue&type=template&id=0b469fae&scoped=true"
import script from "./headerv2.vue?vue&type=script&lang=js"
export * from "./headerv2.vue?vue&type=script&lang=js"
import style0 from "./headerv2.vue?vue&type=style&index=0&id=0b469fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b469fae",
  null
  
)

export default component.exports